import { render, staticRenderFns } from "./Partie3.vue?vue&type=template&id=33d55e52&"
import script from "./Partie3.vue?vue&type=script&lang=js&"
export * from "./Partie3.vue?vue&type=script&lang=js&"
import style0 from "./Partie3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports